module.exports = __webpack_public_path__ + "static/media/tpps_logo.1a13ccc9.png";